/* Dev-only logger: silent in production builds. */
const enabled = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (...args) => { if (enabled) console.error(...args); }, // eslint-disable-line no-console
  warn: (...args) => { if (enabled) console.warn(...args); }, // eslint-disable-line no-console
  info: (...args) => { if (enabled) console.info(...args); }, // eslint-disable-line no-console
};
